// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3Bh_s","col":"Table_col__KnBxQ","fulfillmentStatus":"Table_fulfillmentStatus__2NKBS","emailCol":"Table_emailCol__10kqK"};